import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable} from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerOverlayService } from './spinner-overlay.service';
import { EN_SEGUNDO_PLANO } from './peticion-de-fondo';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(
   private readonly spinnerOverlayService: SpinnerOverlayService
    ) {}

  intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
    // Las peticiones de fondo —una pantalla que se refresca sola— no
    // tapan la app: nadie pulsó nada, así que nadie está esperando.
    // Todo lo demás sigue igual que siempre.
    if (req.context.get(EN_SEGUNDO_PLANO)) {
      return next.handle(req);
    }

    let delayExpired = false;

    const timeout = setTimeout(() => {
      delayExpired = true;
      this.spinnerOverlayService.show();
    }, 100);

    return next.handle(req).pipe(
      finalize(() => {
        clearTimeout(timeout);
        if (delayExpired) {
          this.spinnerOverlayService.hide();
        }
      })
    );
  }
}
